<template>
    <v-container fluid>
        <template v-if="this.customer">
            <v-card class="mb-5 pa-2">
                <card-header
                    :title="
                        $t('customer.title', {
                            'title-prefix': $t('customer.show.title-prefix'),
                        })
                    "
                    :showBackButton="true"
                >
                </card-header>
                <v-card-text>
                    <v-row>
                        <v-col
                            :cols="customer.activePlan ? 6 : 12"
                            xs="12"
                            sm="12"
                            :md="customer.activePlan ? 6 : 12"
                        >
                            <v-card elevation="0" class="grey lighten-4 pa-3">
                                <v-card-text class="pa-1">
                                    <div>{{ this.customer.trade_name }}</div>

                                    <v-row no-gutters>
                                        <v-col>
                                            <p class="headline text--primary">
                                                {{ this.customer.legal_name }}
                                            </p>
                                        </v-col>
                                        <v-col>
                                            <div class="text-right subtitle-1">
                                                <strong v-if="this.customer.cpf"
                                                    >{{
                                                        $t(
                                                            'customer.form.labels.cpf',
                                                        )
                                                    }}:</strong
                                                >
                                                <strong v-else>{{
                                                    $t(
                                                        'customer.form.labels.cnpj',
                                                    )
                                                }}</strong>
                                                {{ this.customer.document }}
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card-text>

                                <v-divider></v-divider>

                                <v-card-text class="d-flex">
                                    <span>
                                        <v-icon small left>mdi-phone</v-icon>
                                        {{ this.customer.phone }}
                                    </span>

                                    <v-divider
                                        class="mx-4"
                                        vertical
                                    ></v-divider>

                                    <span>
                                        <v-icon small left>mdi-email</v-icon>
                                        {{ this.customer.email }}
                                    </span>
                                </v-card-text>

                                <v-divider></v-divider>

                                <v-card-text class="d-flex">
                                    <span>
                                        <span class="caption"
                                            >{{
                                                $t(
                                                    'customer.expanded.login-code',
                                                )
                                            }}:</span
                                        >
                                        {{ this.customer.erp_login_code }}
                                    </span>

                                    <v-divider
                                        class="mx-4"
                                        vertical
                                    ></v-divider>

                                    <span>
                                        <span class="caption">Schema:</span>
                                        {{ this.customer.erp_contract_id }}
                                    </span>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col align-self="center" v-if="customer.activePlan">
                            <div>
                                <v-row class="text-center">
                                    <v-col class="py-5">
                                        <div class="body-3 font-weight-light">
                                            {{
                                                $t(
                                                    'customer.plan.last-plan-name',
                                                )
                                            }}
                                        </div>
                                        <h3 class="display-1 font-weight-light">
                                            {{ customer.activePlan.name }}
                                        </h3>
                                    </v-col>
                                    <v-divider vertical></v-divider>
                                    <v-col class="py-5">
                                        <div class="body-3 font-weight-light">
                                            {{
                                                $t(
                                                    'customer.plan.plan-select-date',
                                                )
                                            }}
                                        </div>
                                        <h3 class="headline font-weight-light">
                                            {{
                                                customer.activePlan
                                                    .formattedActivatedAt
                                            }}
                                        </h3>
                                    </v-col>
                                </v-row>
                                <v-row class="text-center">
                                    <v-col class="py-5">
                                        <div class="font-weight-light">
                                            {{ $t('customer.plan.plan-value') }}
                                        </div>
                                        <v-row>
                                            <v-col
                                                v-if="!isBillable"
                                                class="font-weight-light d-flex flex-column"
                                            >
                                                <span class="headline">
                                                    {{
                                                        $n(
                                                            customer.activePlan
                                                                .value,
                                                            'currency',
                                                        )
                                                    }}
                                                </span>
                                                <span class="body-2">
                                                    {{
                                                        $t(
                                                            'customer.plan.plan-value-total',
                                                        )
                                                    }}
                                                </span>
                                            </v-col>
                                            <v-col
                                                class="font-weight-light d-flex flex-column"
                                            >
                                                <span class="headline">
                                                    {{
                                                        $n(
                                                            customer.activePlan
                                                                .final_price,
                                                            'currency',
                                                        )
                                                    }}
                                                </span>
                                                <span
                                                    class="body-2"
                                                    v-if="!isBillable"
                                                >
                                                    {{
                                                        $t(
                                                            'customer.plan.plan-value-discount',
                                                        )
                                                    }}
                                                </span>
                                                <span
                                                    class="body-2"
                                                    v-if="isBillable"
                                                >
                                                    {{
                                                        $t(
                                                            'customer.plan.plan-value-cplug',
                                                        )
                                                    }}
                                                </span>
                                            </v-col>
                                            <v-col
                                                v-if="isBillable"
                                                class="font-weight-light d-flex flex-column"
                                            >
                                                <span class="headline">
                                                    {{
                                                        $n(
                                                            customer.activePlan
                                                                .over_value,
                                                            'currency',
                                                        )
                                                    }}
                                                </span>
                                                <span class="body-2">
                                                    {{
                                                        $t(
                                                            'customer.plan.plan-value-customer',
                                                        )
                                                    }}
                                                </span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-divider vertical></v-divider>
                                    <v-col class="py-5">
                                        <div class="body-3 font-weight-light">
                                            {{
                                                $t('customer.plan.payment-day')
                                            }}
                                        </div>
                                        <h3 class="display-1 font-weight-light">
                                            {{ customer.activePlan.due_day }}
                                        </h3>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>

                    <v-row class="mt-4">
                        <v-col
                            cols="12"
                            xs="12"
                            sm="12"
                            md="12"
                            :lg="customer.periods.length ? 6 : 12"
                            v-if="customer.activePlan"
                        >
                            <v-divider class="mb-5"></v-divider>
                            <ModulesTable
                                :planId="customer.activePlan.id"
                                :isBillable="isBillable"
                            />
                        </v-col>

                        <v-col
                            cols="12"
                            xs="12"
                            sm="12"
                            md="12"
                            lg="6"
                            v-if="customer.periods.length"
                        >
                            <v-divider class="mb-5"></v-divider>
                            <v-row>
                                <PeriodsIndex
                                    :customer_id="customer.id"
                                    :showHeader="true"
                                    :noGutters="false"
                                    :onlyColumns="[
                                        'plan_name',
                                        'formattedStartAt',
                                        'formattedEndAt',
                                        'formattedValue',
                                        'formattedPaidAt',
                                    ]"
                                />
                            </v-row>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="12" lg="6">
                            <v-divider class="mb-5"></v-divider>
                            <v-card flat>
                                <v-card-title>
                                    <card-header
                                        :title="
                                            $tc(
                                                'resources.cancellationRequisition.name',
                                                2,
                                            )
                                        "
                                    >
                                    </card-header>
                                </v-card-title>
                                <v-card-text>
                                    <cancellation-requisitions-table
                                        :customer_id="id"
                                    />
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </template>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import CancellationRequisitionsTable from '@/views/cancellationRequisitions/Table'
import CardHeader from '@/shared/components/CardHeader'
import CustomerModel from '@/models/Customer'
import ModulesTable from '@/components/table/ModulesTable'
import PeriodsIndex from '@/views/periods/Index'

export default {
    props: ['id'],

    data: () => {
        return {
            customer: null,
        }
    },

    components: {
        CancellationRequisitionsTable,
        ModulesTable,
        CardHeader,
        PeriodsIndex,
    },

    methods: {
        async getCustomer() {
            let customer = await this.model.find(this.id)
            this.customer = customer
        },

        saved() {
            this.$router.push({ name: 'customer.index' })
        },
    },

    computed: {
        model() {
            return new CustomerModel()
        },

        isBillable() {
            return this.customer.reseller.billable
        },
    },

    created() {
        this.getCustomer()
    },
}
</script>
